import { useEffect, useRef, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory, useLocation } from 'react-router'
import { toast, } from 'react-toastify';
import { useAppContext } from '../../../appProvider/contextProvider';
import IconCropper from '../../../components/IconCropper/iconCropper';
import { getImageName } from '../../../components/SegmentModal/getImageName';
import { ERRORS } from '../../../constants/AppConstants';
import { getThemes, setTheme } from '../../../services/topicsService';

import getCroppedImage from '../../../Util/getCroppedImage';


const ThemeSettings = () => {

    const history = useHistory();
    const location = useLocation();

    const { selectedWebsite, 
        setDiscardPromptOpen,
        setPathToNavigate,
        isDirty, 
        setIsDirty,
    } = useAppContext();

    const [theme, setThemes] = useState(null);

    const [selectedTheme, setSelectedTheme] = useState('default');


    const [backgroundColor, setBackgroundColor] = useState('');
    
    const [ topics ] = useState(location.state || []);

    const [ title, setTitle ] = useState('');
    const [ titleColor, setTitleColor] = useState('');
    const [ titleError, setTitleError ] = useState(null);


    const [ cancelText, setCancelText ] = useState('');
    const [ cancelTextColor, setCancelTextColor] = useState('');
    const [ cancelTextError, setCancelTextError ] = useState(null);


    const [ topicTextColor, setTopicBtTextColor] = useState('');
    const [ topicBgColor, setTopicBgColor ] = useState('');

    const [ activeTopicTextColor, setActiveTopicTextColor] = useState('');
    const [ activeTopicBgColor, setActiveTopicBtnBgColor ] = useState('');

    const [ allowBtnText, setBtnAllowText ] = useState('');
    const [ btnAllowTextColor, setBtnAllowTextColor] = useState('');
    const [ btnAllowBgColor, setBtnAllowBgColor ] = useState('');
    const [ btnAllowTextError, setBtnAllowTextError ] = useState(null);

    const [ description, setDescription ] = useState('');
    const [descriptionColor, setDescriptionColor] = useState('');

    const [imageUrl, setImageUrl] = useState('');
    const [imageName, setImageName] = useState('');
    const [openCropper, setOpenCropper] = useState(false);
    const [bgImage, setBGImage] = useState(null);

    
    const iconRef = useRef(null);

    useEffect(() => {
        const discard = () => {
            setInitial();
        }
        document.addEventListener('discardEvent', discard);

        return () => {
            document.removeEventListener('discardEvent', discard);
        }
    }, [])

    useQuery(['fetchThemes', selectedWebsite?.id],  () => getThemes(selectedWebsite?.id), {
        enabled: !!selectedWebsite,
        onSuccess: ((themes) => {
            if(themes.errors) {

            }else {
                setThemes(themes);
                setInitial(themes);
            }
        })
    });


    const handelTitleChange = (value) => {
        setIsDirty(true);
        if(value.trim().length <=0 ) {
            setTitleError(ERRORS.TITLE_REQUIRED);
        } 
        else {
            setTitleError(null);
        }
        if(value.trim().length <= 25) {
            setTitle(value.trim());
        }
    }

    const handelCancelTextChange = (value) => {
        setIsDirty(true);
        if(value.trim().length <=0 ) {
            setCancelTextError(ERRORS.TITLE_REQUIRED);
        }
        else {
            setCancelTextError(null);
        }
        if(value.trim().length <= 15) {
            setCancelText(value.trim());
        }
    }

    const handelAllowTextChange = (value) => {
        setIsDirty(true);
        if(value.trim().length <=0 ) {
            setBtnAllowTextError(ERRORS.TITLE_REQUIRED);
        }
        else {
            setBtnAllowTextError(null);
        }
        if(value.trim().length <= 10) {
            setBtnAllowText(value.trim());
        }

    }


    const isSaveDisabled = () => {
        return title.length <= 0 || cancelText.length <= 0 || allowBtnText.length <= 0 ||(selectedTheme === 'theme2' && imageUrl.length <=0)
            ||  titleError || cancelTextError || btnAllowTextError;
    }

    const handelImageUpload = (({target}) => {
        if(target.files && target.files[0]) {
            setIsDirty(true);
            const url = URL.createObjectURL(target.files[0]);
            setImageName(target.files[0].name);
            setImageUrl(url);
            iconRef.current.value = '';
            setOpenCropper(true);
        }
    });

    const onCancelIconCrop = () => {
        setImageUrl('');
        setOpenCropper(false);
    }
    
    const getCroppedIcon = async (croppedAreaPixel) => {
        const {url, file} = await getCroppedImage(
            imageUrl,
            croppedAreaPixel,
            0,
            imageName,
        );
        setImageUrl(url);
        setBGImage(file);
        setOpenCropper(false);
    }


    const setInitial = (theme) => {

        setTitleError(null);
        setCancelTextError(null);
        setBtnAllowTextError(null);
        
        setSelectedTheme(theme?.type || 'default');

        setTitle(theme?.title || '');
        setTitleColor(theme?.title_color || '');
        
        setTopicBtTextColor(theme?.topic_btn_text_color || '');
        setTopicBgColor(theme?.topic_btn_bg_color || '');

        setActiveTopicBtnBgColor(theme?.selected_topic_btn_bg_color || '');
        setActiveTopicTextColor(theme?.selected_topic_btn_text_color || '');

        setCancelText(theme?.cancel_btn_text || '');
        setCancelTextColor(theme?.cancel_btn_color || '');

        setBtnAllowText(theme?.subscribe_btn_text || '');
        setBtnAllowTextColor(theme?.subscribe_btn_color || '');
        setBtnAllowBgColor(theme?.subscribe_btn_bg || '');

        setDescription(theme?.description || '');
        setDescriptionColor(theme?.description_color || '');

        setBackgroundColor(theme?.background || '');
        
        setImageUrl(theme?.bg_image || '');

    }

    const save = (event) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append('type', selectedTheme);
        formData.append('title', title);
        formData.append('title_color', titleColor);
        formData.append('cancel_btn_text', cancelText);
        formData.append('cancel_btn_color', cancelTextColor);
        formData.append('subscribe_btn_text', allowBtnText);
        formData.append('subscribe_btn_color', btnAllowTextColor);
        formData.append('subscribe_btn_bg', btnAllowBgColor);
        formData.append('description', description);
        formData.append('description_color', descriptionColor);
        formData.append('background', backgroundColor);
        formData.append('topic_btn_text_color', topicTextColor);
        formData.append('topic_btn_bg_color', topicBgColor);
        formData.append('selected_topic_btn_text_color', activeTopicTextColor);
        formData.append('selected_topic_btn_bg_color', activeTopicBgColor);
        
        if(selectedTheme === 'theme2' && bgImage) {
            formData.append('bg_image', bgImage);
        }

        setIsDirty(false);

        setTopicTheme.mutate(formData);
    }

    const setTopicTheme = useMutation((formData) => {
        return setTheme(selectedWebsite?.id, formData)
    }, {
        onSuccess: ((themeDetails) => {
            if(themeDetails?.errors) {

            } else {
                toast.success('Theme settings updated successfully');
            }
        })
    });


    const discard = () => {
        setDiscardPromptOpen(true);
    }

    const onBack = () => {
        if(isDirty) {
            setDiscardPromptOpen(true);
            setPathToNavigate('/topics');
        } else {
            history.push('/topics')
        }
    }

    const onChangeTheme = (value) => {
        setIsDirty(true);
        setSelectedTheme(value);
    }


    return <>
        <div className="panel full-height">
            <div className="panel-header">
                <div className="d-flex flex-wrap justify-content-between align-items-space-between">
                            <div>
                            <h3 className="mb-0"><i className="icon icon-chevron-left mr-2" onClick= {onBack} ></i>Topics Themes Settings</h3>
                            </div>
                            <div className="d-flex justify-content-between " style={{gap: '10px'}}>
                                <button className="btn btn-sm btn-danger" onClick={discard} >Discard</button>
                                <button className="btn btn-sm btn-primary" onClick={save} disabled={isSaveDisabled()} >Save</button>                                         
                            </div> 
                        </div>                                
            </div>
            <div className="panel-body full-height scrollable_y">
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <h6 className="regular text-light mb-2">Select a Theme for the design of the Segments dialog.</h6>
                        <div className="d-flex flex-column">
                            <div className="panel mb-3">
                                <div className="panel-header p-2 d-flex align-items-center justify-content-between">
                                    <h6 className="mb-0">Topics Theme</h6>
                                    <button className="btn btn-neutral"><i className="increment-icon default"></i></button>
                                </div>
                                <div className="panel-body p-3">
                                    <div className="form-group mb-0">
                                        <div className="custom-select">
                                            <select value={selectedTheme} onChange={({target}) => onChangeTheme(target.value)} className="form-control">
                                                <option value="default">Theme 1</option>
                                                <option value="theme2">Theme 2</option>
                                                {/* <option value="Theme_1">Theme 3</option> */}
                                            </select>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                            <div className="panel">
                                <div className="panel-header p-2 d-flex align-items-center justify-content-between">
                                    <h6 className="mb-0">Content &amp; Appearance</h6>
                                    <button className="btn btn-neutral"><i className="increment-icon default"></i></button>
                                </div>
                                <div className="panel-body p-3 scrollable_y">
                                    { selectedTheme === 'theme2' && <div className="form-group">
                                        <label className="text-dark medium">Image *</label>
                                        <div className="d-flex">
                                            <input type="text"
                                                    value={(bgImage !== null && bgImage !== theme?.bg_image) ? imageName : getImageName(theme?.bg_image)} 
                                                    disabled={true} 
                                                    onChange={() => {}} 
                                                    className="form-control"/>
                                            <div className="file-upload ml-2">                                            
                                                <input 
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(event) => handelImageUpload(event)}
                                                    ref={iconRef}
                                                />
                                                <i className="icon icon-file"></i>
                                                Select File
                                            </div>  
                                        </div>
                                    </div> }
                                    <div className="form-group">
                                        <label className="text-dark medium full-width">Title *<span className="float-right" >{title.length} / 25</span></label>
                                        <div className="d-flex ">
                                            <input 
                                                type="text"
                                                className="form-control"
                                                value = {title}
                                                onChange={({target}) => handelTitleChange(target.value)}
                                                maxLength={25}
                                                />
                                            <input 
                                                type="color" 
                                                value={titleColor}
                                                onChange={({target}) => setTitleColor(target.value)}
                                                className="mx-2"/>                                                        
                                        </div>
                                        { titleError && <div><span className="error-message">{titleError}</span></div>}
                                    </div>
                                    <div className="form-group">
                                        <label className="text-dark medium full-width">Topics</label>
                                        <div className="d-flex ">
                                            <input
                                                type="color"
                                                className="mx-2"
                                                value={topicBgColor}
                                                onChange={({target}) => setTopicBgColor(target.value)}
                                            />
                                            <input
                                                type="color"
                                                className=""
                                                value={topicTextColor}
                                                onChange={({target}) => setTopicBtTextColor(target.value)}
                                            />                                                        
                                        </div>
                                    </div>
                                    {/* <div className="form-group">
                                        <label className="text-dark medium full-width">Selected/Clicked Topics </label>
                                        <div className="d-flex ">
                                            <input
                                                type="color"
                                                value="#F09C53"
                                                className="mx-2"
                                                value={activeTopicBgColor}
                                                onChange={({target}) => setActiveTopicBtnBgColor(target.value)}
                                            />
                                            <input
                                                type="color"
                                                value="#ffffff"
                                                className=""
                                                value={activeTopicTextColor}
                                                onChange={({target}) => setActiveTopicBtnBgColor(target.value)}
                                            />                                                      
                                        </div>
                                    </div> */}
                                    {/* <div className="text-right">
                                        <button className="btn btn-link btn-xs"><i className="icon icon-add mr-2"></i>Add Option</button>
                                    </div> */}
                                    <div className="form-group">
                                        <label className="text-dark medium full-width">Cancel Text *<span className="float-right">{cancelText.length} / 15</span></label>
                                        <div className="d-flex ">
                                            <input 
                                                type="text" 
                                                value={cancelText}
                                                onChange={({target}) => handelCancelTextChange(target.value)}
                                                className="form-control"
                                                maxLength={15}
                                                />

                                            <input 
                                                    type="color"
                                                    className="mx-2"
                                                    value={cancelTextColor}
                                                    onChange={({target}) => setCancelTextColor(target.value)}
                                                />
                                        </div>
                                        { cancelTextError && <div><span className="error-message">{cancelTextError}</span></div>}
                                    </div>
                                    <div className="form-group">
                                        <label className="text-dark medium full-width">Allow Button *<span className="float-right">{allowBtnText.length} / 10</span></label>
                                        <div className="d-flex ">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={allowBtnText}
                                                onChange={({target}) => handelAllowTextChange(target.value)}
                                                maxLength={10}
                                            />
                                            <input 
                                                type="color"
                                                className="mx-2"
                                                value={btnAllowBgColor}
                                                onChange={({target}) => setBtnAllowBgColor(target.value)}/>
                                            <input
                                                type="color"
                                                className=""
                                                value={btnAllowTextColor}
                                                onChange={({target}) => setBtnAllowTextColor(target.value)}
                                            />                                                        
                                        </div>
                                        { btnAllowTextError && <div><span className="error-message">{btnAllowTextError}</span></div>}
                                    </div>
                                    <div className="form-group">
                                        <label className="text-dark medium full-width">Description <span className="float-right">{description.length} / 100</span></label>
                                        <div className="d-flex ">
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                rows="2"
                                                value={description}
                                                onChange={({target}) => setDescription(target.value)}
                                                maxLength={100}
                                            ></textarea>
                                            <input 
                                                type="color"
                                                className="mx-2"
                                                value={descriptionColor}
                                                onChange={({target}) => setDescriptionColor(target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group d-flex align-items-center">
                                        <label className="text-dark medium">Background</label>
                                        <input 
                                            type="color"
                                            className="ml-auto"
                                            value={backgroundColor}
                                            onChange={({target}) => setBackgroundColor(target.value)}
                                        />
                                    </div>
                                </div>
                            </div>                                            
                        </div>                                    
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-8">
                        { 
                            selectedTheme === 'theme2' &&  <div className="theme-preview-container"  style={{background: backgroundColor, position: 'sticky', top: '0'}}>
                                <div className="theme-image" 
                                style={{backgroundImage: `url(${(bgImage !== null && bgImage !== theme?.bg_image) ? imageUrl: theme?.bg_image})` }}>
                                </div>                                            
                                <div className="theme-description d-flex flex-column">                                                
                                    <h5 className="regular mb-3 text-center" style={{color: titleColor}} >{title}</h5>
                                    <div className="d-flex flex-wrap theme-graphic">
                                    {
                                        topics.map(({name}, index) =>  <button 
                                                className="btn mb-2 topic-btn"
                                                key={index}
                                                style={{
                                                    color: topicTextColor,
                                                    background: topicBgColor,
                                                    borderColor: topicBgColor
                                                }}     
                                            >{name}</button>)
                                    }
                                    </div>
                                    <div className="mb-4 mt-2 d-flex justify-content-center">
                                        <div className="col-6 text-center">
                                            <a 
                                                className="text-white"
                                                style={{color: cancelTextColor}}
                                            >{cancelText}</a>
                                        </div>
                                        <div className="col-6 text-center">
                                            <button
                                                className="btn btn-orange ml-3"
                                                style={{color: btnAllowTextColor, background: btnAllowBgColor, borderColor: btnAllowBgColor}}    
                                            >{allowBtnText}</button>
                                        </div>
                                    </div>          
                                    <p className="text-center" style={{color: descriptionColor,' word-break': 'break-word'}}>{description}</p>
                                </div>                                            
                            </div>
                        }
                        {
                            selectedTheme === 'default' && <div className="theme-preview-container" style={{background: backgroundColor,  position: 'sticky', top: '0'}} data-theme="descriptive">
                                <div className="theme-description full-width d-flex flex-column justify-content-center">                                                
                                    <h5 className="regular mb-3 text-center" style={{color: titleColor}} >{title}</h5>
                                    <div className="row">
                                        {
                                            topics.map(({name}, index) => <div key={index} className="col col-sm-6">
                                                    <button style={{
                                                        color: topicTextColor,
                                                        background: topicBgColor,
                                                        borderColor: topicBgColor,
                                                        }}     className="btn btn-block topic-btn mb-2">{name}</button>
                                                </div>)
                                        }
                                       
                                    </div>                                                
                                    <div className="mb-3 mt-2 d-flex justify-content-center">
                                        <div className="col-6 text-center">
                                            <a href="" className="text-white primary-link" style={{color: cancelTextColor}}>{cancelText}</a>
                                        </div>
                                        <div className="col-6 text-center">
                                            <button className="btn btn-orange" style={{color: btnAllowTextColor, background: btnAllowBgColor, borderColor: btnAllowBgColor}} >{allowBtnText}</button>
                                        </div>
                                    </div>          
                                    <p className="text-center px-5" style={{color: descriptionColor, ' word-break': 'break-word'}}>{description}</p>
                                </div>                                            
                            </div>
                        }
                    </div>
                </div>                                
            </div>
        </div>

        { openCropper && <IconCropper
            open={openCropper} 
            onClose={onCancelIconCrop} 
            url={imageUrl} 
            onSave={getCroppedIcon} 
            aspect={1 / 1}
        />}

</>
}


export default ThemeSettings;